import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Images } from "lucide-react";

export default function StayGalleries({ s, galleries, onSaved }) {
  const [sel, setSel] = useState(s.gallery_ids);
  const toggle = (id) => setSel((l) => (l.includes(id) ? l.filter((x) => x !== id) : [...l, id]));
  const save = async (open) => {
    if (open) { setSel(s.gallery_ids); return; }
    if (sel.join() === s.gallery_ids.join()) return;
    try { await api.put(`/photo-stays/${s.booking_id}/galleries`, { gallery_ids: sel }); toast.success("Gallerie salvate"); onSaved(); }
    catch (e) { setSel(s.gallery_ids); toast.error(formatApiError(e)); }
  };
  return (
    <Popover onOpenChange={save}>
      <PopoverTrigger asChild>
        <button data-testid={`stay-galleries-${s.booking_id}`} className={`inline-flex items-center gap-1 text-sm px-3 py-1.5 rounded-md border ${s.gallery_ids.length ? "border-sky-300 text-sky-800 bg-sky-50" : "border-rose-300 text-rose-700"}`}>
          <Images size={14} /> {s.gallery_ids.length ? `${s.gallery_ids.length} gallerie` : "Scegli gallerie"}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" collisionPadding={12} className="w-72 max-h-80 overflow-y-auto" data-testid={`stay-galleries-pop-${s.booking_id}`}>
        <div className="text-xs font-semibold text-slate-500 mb-2">Gallerie che questa camera può scaricare</div>
        {galleries.length === 0 && <div className="text-sm text-slate-400">Nessuna galleria caricata</div>}
        {galleries.map((g) => (
          <label key={g.id} className="flex items-center gap-2 text-sm py-1">
            <input type="checkbox" checked={sel.includes(g.id)} onChange={() => toggle(g.id)} data-testid={`stay-gal-${s.booking_id}-${g.id}`} />
            <span className="truncate">{g.title}</span>
            <span className="ml-auto text-[10px] text-slate-400">{g.created_at.slice(0, 10).split("-").reverse().join("/")}</span>
          </label>
        ))}
        <div className="text-[11px] text-slate-400 mt-2">Si salva quando chiude questa finestra.</div>
      </PopoverContent>
    </Popover>
  );
}
